import styled from '@xstyled/styled-components';
import React from 'react';
import { AudioCompletionProvider } from '~/training/sequence/AudioCompletion';
import {
  Item,
  ItemDefinition,
  ItemValidationError,
  RenderProps
} from '../Item';
import { ROOT } from '../itemIds';

const RootEl = styled.div`
  /* Keep negative-z backgrounds inside the slide, above the containing page. */
  isolation: isolate;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  > * {
    grid-column: 1;
    grid-row: 1;
  }

  a {
    color: var(--color-accent-fg);
  }

  .imageForQuote7 {
    margin-bottom: 20px;
    margin-right: 20px;
    margin-left: -20px;
    max-width: 250px;
    @media (max-width: sm) {
      display: none;
    }
  }

  @media only screen and (min-width: sm) and (max-width: 1024px) and (orientation: portrait) {
    .left_CardInHalfPage {
      background-color: unset;
    }
  }
  @media (max-width: sm) {
    grid-template-rows: unset;
    .bgImage {
    }
    .emptyBgImage {
      display: none;
    }
  }
`;

export type RootDefinition = ItemDefinition<typeof ROOT, void>;

export class Root extends Item<typeof ROOT, void> {
  protected validate(): void {
    if (this.parent)
      throw new ItemValidationError(
        `An item of type ${ROOT} must not have any parent`
      );
  }

  protected render({ children }: RenderProps<void>) {
    return (
      <AudioCompletionProvider>
        <RootEl>{children}</RootEl>
      </AudioCompletionProvider>
    );
  }
}
